import { createAsyncThunk } from "@reduxjs/toolkit";

import { conditionRuleset } from "./helpers/conditionRuleset";

import { requestStep4 } from "../apiRequests/requestStep4";

export const requestDesignUpdate = createAsyncThunk(
  "thunks/requestDesignUpdate",
  async (
    data = { uterumProperties: null, uterumParams: null, meta: null },
    thunkAPI
  ) => {
    const state = thunkAPI.getState();
    const { requests, Uterum } = state;
    const { apiConfigs } = requests;

    (!data || Object.keys(data).length === 0) &&
      console.error(`Unexpected data in thunks/requestDesignUpdate: ${data}`);

    Object.keys(data).some(
      (key) =>
        key !== "uterumProperties" &&
        key !== "uterumParams" &&
        key !== "meta" &&
        console.error(`Unexpected key in thunks/requestDesignUpdate: ${key}`)
    );

    const partiType = data && data.meta ? data.meta.dispatchedBy : null;

    const additionalParams = partiType
      ? {
          ...data.uterumParams,
          area:
            partiType === "Parti"
              ? Uterum.SelectedFrameArea
              : partiType === "topParti"
              ? Uterum.SelectedTopWindow
              : "",
        }
      : data.uterumParams;

    const response = await requestStep4({
      apiConfigs,
      additionalParams,
      data:
        data && data.uterumProperties
          ? { ...Uterum, ...data.uterumProperties }
          : Uterum,
      onSuccess: (response) => {
        return {
          ...response,
          data: {
            cgeObj: response.data,
          },
        };
      },
    });

    return response.data;
  },
  conditionRuleset
);
